import React from "react";
import styles from "./style.module.css";
import { useRecoilState } from "recoil";
import { navigationState } from "recoil/atoms";
import { TNavigation } from "data/navigation";
import { useLocation, useNavigate } from "react-router-dom";
import useModal from "hooks/useModal";

interface INavigation {
  nav: TNavigation;
  img: string;
  activeImg: string;
  text: string;
  navUrl: string;
}

export default function Nav({ isVisible = true }: { isVisible: boolean }) {
  const location = useLocation();
  if (
    // !location.pathname.includes("review") &&
    location.pathname.includes("/company/detail")
  )
    return null;
  const [activeNav, setActiveNav] = useRecoilState(navigationState);
  const navigate = useNavigate();
  const { removeModal } = useModal();

  const navData: INavigation[] = [
    {
      nav: "detail",
      img: "/images/nav01.png",
      activeImg: "/images/nav01-active.png",
      text: "홈",
      navUrl: "/",
    },
    {
      nav: "company",
      img: "/images/nav02.png",
      activeImg: "/images/nav02-active.png",
      text: "예약센터",
      navUrl: "/wedding/hall",
    },
    {
      nav: "mypage",
      img: "/images/nav03.png",
      activeImg: "/images/nav03-active.png",
      text: "내 정보",
      navUrl: "/SignIn",
    },
  ];

  return (
    <nav className={isVisible ? styles.nav : styles.hide}>
      <ul>
        {navData.map(({ nav, img, activeImg, text, navUrl }) => {
          const isActive = nav === activeNav;

          function onClick() {
            setActiveNav(nav);
            navigate(navUrl);
            removeModal("CANCEL_MODAL" || "CANCEL_MODAL");
          }

          return (
            <li key={text} onClick={onClick}>
              <img src={isActive ? activeImg : img} alt={text} />
              <p>{text}</p>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
